import React, { useContext, useEffect, useState } from "react";
import classes from "./GRN.module.css";
import { useSelector } from "react-redux/es/hooks/useSelector";

// import componentns
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import { Modal, Fade, Box, Tabs, Tab, TablePagination } from "@mui/material";

import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";

import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import Select from "react-select";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { CurrencyContext } from "../../../context/CurrencyContext";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useLocation } from "react-router-dom";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";

const GRNSystem = () => {
  const loginData = useSelector((state) => state.loginData.value);

  const profilePath = "/Organization_dashboard/My_profile";

  console.log(loginData);

  const {
    fromCurrency,
    setFromCurrency,
    toCurrency,
    countryName,
    setToCurrency,
    firstAmount,
    setFirstAmount,
  } = useContext(CurrencyContext);

  const location = useLocation();

  const [user_token] = useState(loginData?.user?.token);
  const [auth_token] = useState(loginData?.auth_token);

  const [access_type] = useState(loginData?.access_type);
  const [designation] = useState(loginData?.user?.designation);

  const [user_details] = useState(loginData?.user);
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);

  // state for within component
  const [getviewgrn, setViewGRN] = useState(false);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [items, setItems] = useState({});

  const [getponumber, setPONumber] = useState([]);
  const [getpoItems, setPoItems] = useState([]);

  const [userlist, setUserList] = useState([]);

  const [successpopup, setSuccessPopUp] = useState(false);
  const [getuserpopupherotext, setUserPopupHeroText] = useState("");

  const [grnData, SetGrnData] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const [searchText, setSearchText] = useState("");
  const ROWS_PER_PAGE = 10;

  const [activePage, setActivePage] = useState(1);
  const [completedPage, setCompletedPage] = useState(1);
  const [poInvoiceMap, setPoInvoiceMap] = useState({});

  // api calls

  const getAllPoNumbers = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_purchase_order}`,
        { user_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      const poNumbers = response?.data?.map((po) => ({
        poNo: po.purchase_order_no,
        supplier: po.vendor?.company_name || "",
        invoiceNo: po.invoice_number || "",
      }));
      setPONumber(poNumbers);
      const invoiceMap = {};
      response?.data?.forEach((po) => {
        invoiceMap[po.purchase_order_no] = po.invoice_number;
      });

      setPoInvoiceMap(invoiceMap);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const getAllItems = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.view_all_item}`,
        { org_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      if (response.data?.response) {
        setPoItems(response?.data?.response);
      } else {
        console.error("API response is not an array:", response.data);
        setPoItems([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setPoItems([]);
    }
  };

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      setUserList(response?.data);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const getALLGrn = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_saved_grn}`,
        { token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      if (response.data?.response) {
        SetGrnData(response?.data?.response);
      } else {
        console.error("API response is not an array:", response.data);
        SetGrnData([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      SetGrnData([]);
    }
  };

  useEffect(() => {
    getAllPoNumbers();
    getAllItems();
    getAllUserList();
    getALLGrn();
  }, []);

  // useEffect(() => {
  //   const hash = window.location.hash || "";
  //   const query = hash.split("?")[1] || "";
  //   const params = new URLSearchParams(query);

  //   if (params.get("action") === "create") {
  //     setViewGRN(true); //
  //   }
  // }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const action = params.get("action");
    if (action === "create") {
      setViewGRN(true);
    }
  }, [location.search]);

  // useEffect(() => {
  //   if (fromCurrency?.currency && toCurrency?.currency) {
  //     axios(`https://v6.exchangerate-api.com/v6/YOUR_API_KEY/latest/${fromCurrency.currency}`)
  //       .then((response) => {
  //         const currencyResponse = response.data;
  //         const rate = currencyResponse.conversion_rates[toCurrency.currency];
  //         setConversionRate(rate || 1);

  //         // Update the converted total price
  //         const convertedPrice = (unitPrice * quantityReceived * rate).toFixed(2);
  //         setConvertedTotalPrice(convertedPrice);
  //       })
  //       .catch((error) => {
  //         console.error("Currency Conversion Error:", error);
  //       });
  //   }
  // }, [fromCurrency, toCurrency, unitPrice, quantityReceived]);

  useEffect(() => {
    setActivePage(1);
    setCompletedPage(1);
  }, [tabValue]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, grn_search } = JSON.parse(chatActionRaw);

    if (action === "search_grn") {
      setSearchText(grn_search);
    }
  }, []);

  const handleAddPO = () => {
    const currentDate = new Date().toISOString().split("T")[0];

    const newPO = {
      id: Date.now(),
      poNo: "",
      supplier: "",
      invoiceNo: "",
      invoiceDate: currentDate,
      receivedBy: "",
      department: "",
    };
    setPurchaseOrders([...purchaseOrders, newPO]);
  };

  const handleRemovePO = (id) => {
    setPurchaseOrders(purchaseOrders.filter((po) => po.id !== id));
    setItems((prev) => {
      const updatedItems = { ...prev };
      delete updatedItems[id];
      return updatedItems;
    });
    if (selectedPO === id) setSelectedPO(null);
  };

  const handlePOInputChange = (id, field, value) => {
    console.log({ field, value });
    setPurchaseOrders(
      purchaseOrders.map((po) => {
        if (po.id === id) {
          let updatedPO = { ...po, [field]: value };

          if (field === "receivedBy") {
            const selectedUser = userlist.find(
              (user) => user.first_name === value
            );
            if (selectedUser) {
              updatedPO.received_email = selectedUser.email;
              updatedPO.department = selectedUser.department;
            }
          }

          if (field === "poNo") {
            const selectedPO = getponumber.find(
              (poOption) => poOption.poNo === value
            );
            updatedPO.supplier = selectedPO ? selectedPO.supplier : "";
            updatedPO.invoiceNo = selectedPO ? selectedPO.invoiceNo : "";
          }

          return updatedPO;
        }
        return po;
      })
    );
  };

  const getInvoiceItemsByInvoiceNo = async (invoiceNo) => {
    try {
      const res = await axios.post(
        API_ENDPOINT.get_invoice_items_by_invoice_number,
        { invoice_number: invoiceNo },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      return res?.data?.items || [];
    } catch (err) {
      console.error("Invoice item fetch failed", err);
      return [];
    }
  };

  // const handleAddItem = (poId) => {
  //   setItems((prev) => ({
  //     ...prev,
  //     [poId]: [
  //       ...(prev[poId] || []),
  //       {
  //         item_code: "",
  //         name: "",
  //         description: "",
  //         quantityOrdered: "",
  //         quantityReceived: "",
  //         uom: "",
  //         unitPrice: "",
  //         totalPrice: "",
  //         remarks: "",
  //       },
  //     ],
  //   }));
  // };

  const handleAddItem = async (poId) => {
    const selectedPO = purchaseOrders.find((po) => po.id === poId);
    if (!selectedPO?.invoiceNo) return;

    const invoiceItems = await getInvoiceItemsByInvoiceNo(selectedPO.invoiceNo);

    const mappedItems = invoiceItems.map((item) => ({
      item_code: item.item_code,
      name: item.description,
      description: item.description,
      quantityOrdered: item.quantity,
      quantityReceived: "",
      uom: "Pieces",
      unitPrice: item.unit_price,
      totalPrice: item.total_amount,
      remarks: "",
    }));

    setItems((prev) => ({
      ...prev,
      [poId]: mappedItems,
    }));
  };

  const handleRemoveItem = (poId, index) => {
    setItems((prev) => ({
      ...prev,
      [poId]: prev[poId].filter((_, i) => i !== index),
    }));
  };

  // const handleItemInputChange = (poId, index, field, value) => {
  //   setItems((prev) => {
  //     const updatedItems = [...(prev[poId] || [])];

  //     if (field === "item_code") {
  //       const selectedItem = getpoItems.find(
  //         (item) => item.item_code === value
  //       );
  //       if (selectedItem) {
  //         updatedItems[index] = {
  //           ...updatedItems[index],
  //           item_code: selectedItem.item_code,
  //           name: selectedItem.item_name,
  //           description: "",
  //           uom: "Pieces",
  //           unitPrice: 0,
  //           totalPrice: 0,
  //           remarks: "",
  //         };
  //       }
  //     } else {
  //       updatedItems[index][field] = value;
  //     }

  //     updatedItems[index][field] = value;

  //     // Convert values to numbers (ensure proper calculation)
  //     const quantityReceived =
  //       Number(updatedItems[index].quantityReceived) || 0;
  //     const unitPrice = Number(updatedItems[index].unitPrice) || 0;

  //     // Auto-calculate total price
  //     updatedItems[index].totalPrice = quantityReceived * unitPrice;

  //     return { ...prev, [poId]: updatedItems };
  //   });
  // };
  const handleItemInputChange = (poId, index, field, value) => {
    setItems((prev) => {
      const updatedItems = [...(prev[poId] || [])];

      updatedItems[index][field] = value;

      const quantityReceived =
        Number(updatedItems[index].quantityReceived) || 0;
      const unitPrice = Number(updatedItems[index].unitPrice) || 0;

      updatedItems[index].totalPrice = quantityReceived * unitPrice;

      return { ...prev, [poId]: updatedItems };
    });
  };

  console.log(purchaseOrders);

  const handleSaveGRN = async () => {
    const formattedData = purchaseOrders.flatMap((po) => {
      return (items[po.id] || []).map((item) => ({
        user_token: loginData?.user?.user_token,
        poNo: po.poNo,
        supplier_name: po.supplier,
        invoiceNo: po.invoiceNo,
        received_by: po.receivedBy,
        received_email: loginData?.user?.email || "",
        department: po.department,
        item_name: item.name,
        item_code: item.item_code || "",
        description: item.description,
        q_ordered: item.quantityOrdered,
        q_received: item.quantityReceived,
        uom: item.uom,
        unit_price: item.unitPrice,
        remarks: item.remarks,
      }));
    });

    const res = await axios.post(API_ENDPOINT.ins_grn_data, formattedData, {
      headers: {
        Authorization: `Bearer ${auth_token}`,
        "Content-Type": "application/json",
      },
    });

    if (res?.status == 201) {
      setSuccessPopUp(true);
      setUserPopupHeroText("GRN Added Successfully");
      getALLGrn();
    }
  };

  const sentUserMessage = () => {
    setPurchaseOrders([]);
    setItems({});
    setSelectedPO(null);
    setViewGRN(false);
    setSuccessPopUp(false);
  };

  const activeGRN = grnData.filter((grn) => !grn.status);
  const completedGRN = grnData.filter((grn) => grn.status);

  const filterGRNBySearch = (data) => {
    if (!searchText.trim()) return data;

    const q = searchText.toLowerCase();

    return data.filter((grn) =>
      [
        grn.purchase_order_no,
        poInvoiceMap?.[grn.purchase_order_no],
        grn.vendor,
        grn.receiver_name,
        grn.item_name,
      ]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(q))
    );
  };

  const filteredActiveGRN = filterGRNBySearch(activeGRN);
  const filteredCompletedGRN = filterGRNBySearch(completedGRN);

  const paginatedActiveGRN = filteredActiveGRN.slice(
    (activePage - 1) * ROWS_PER_PAGE,
    activePage * ROWS_PER_PAGE
  );

  const paginatedCompletedGRN = filteredCompletedGRN.slice(
    (completedPage - 1) * ROWS_PER_PAGE,
    completedPage * ROWS_PER_PAGE
  );

  return (
    <>
      <div className={classes.rightItems}>
        <DateBar />

        <ProfileCard hideMenu={false} profilePath={profilePath} />
      </div>
      <div className={classes.grncontainer}>
        <div className={classes.viewbtncontainer}>
          <HeaderTitle titleText={"Goods Receipt Note (GRN)"} />

          {access_type !== "Buyer" && designation == "Store Manager" && (
            <button
              onClick={() => {
                setViewGRN(!getviewgrn);
              }}
              className={getviewgrn ? classes.backBtn : classes.viewBtn}
            >
              {getviewgrn ? "Back" : "Add GRN"}
            </button>
          )}
        </div>

        <SearchBar
          value={searchText}
          onChange={(value) => {
            setSearchText(value);
          }}
        />

        <hr></hr>

        {getviewgrn ? (
          <div style={{ width: "100%" }}>
            {/* Company Details */}
            <div className={classes.companydetails}>
              <div className={classes.inputcontainer}>
                <label>Company Name:</label>
                <input value={user_details.company_name} readOnly />
              </div>

              <div className={classes.inputcontainer}>
                <label>Address:</label>
                <input
                  value={`${user_details.city},${user_details.state}`}
                  readOnly
                />
              </div>

              <div className={classes.inputcontainer}>
                <label>Contact Details:</label>
                <input value={`${user_details.email}`} readOnly />
              </div>

              <div className={classes.inputcontainer}>
                <label>Date:</label>
                <input type="date" defaultValue={date} />
              </div>
            </div>

            {/* PO Table */}
            <table className={classes.potable}>
              <thead>
                <tr>
                  <th>PO No.</th>
                  <th>Supplier Name</th>
                  <th>Invoice No.</th>
                  <th>Invoice Date</th>
                  <th>Received By</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Add Items</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrders.map((po, index) => {
                  console.log("Purchase Order Row:", {
                    index: index,
                    id: po.id,
                    poNo: po.poNo,
                    supplier: po.supplier,
                    invoiceNo: po.invoiceNo,
                    invoiceDate: po.invoiceDate,
                    receivedBy: po.receivedBy,
                    received_email: po.received_email,
                    department: po.department,
                  });

                  return (
                    <tr key={po.id}>
                      <td>
                        <select
                          value={po.poNo}
                          onChange={(e) =>
                            handlePOInputChange(po.id, "poNo", e.target.value)
                          }
                        >
                          <option value="">Select PO Number</option>
                          {Array.isArray(getponumber) &&
                            getponumber.map((poOption, index) => (
                              <option key={index} value={poOption.poNo}>
                                {poOption.poNo} - {poOption.supplier}
                              </option>
                            ))}
                        </select>
                      </td>

                      <td>
                        <input type="text" value={po.supplier} readOnly />
                      </td>

                      <td>
                        <input
                          type="text"
                          value={po.invoiceNo}
                          onChange={(e) =>
                            handlePOInputChange(
                              po.id,
                              "invoiceNo",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          value={po.invoiceDate}
                          onChange={(e) =>
                            handlePOInputChange(
                              po.id,
                              "invoiceDate",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      <td>
                        <select
                          value={po.receivedBy}
                          onChange={(e) =>
                            handlePOInputChange(
                              po.id,
                              "receivedBy",
                              e.target.value
                            )
                          }
                        >
                          <option value="">Select User</option>
                          {userlist.map((user) => (
                            <option key={user.token} value={user.first_name}>
                              {user.first_name}
                            </option>
                          ))}
                        </select>
                      </td>

                      <td>
                        <input
                          type="text"
                          value={po.received_email || ""}
                          readOnly
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          value={po.department || ""}
                          readOnly
                        />
                      </td>

                      <td>
                        <button
                          onClick={() =>
                            setSelectedPO(selectedPO === po.id ? null : po.id)
                          }
                          className={classes.iconCircleBtn}
                        >
                          {selectedPO === po.id ? (
                            <AddCircleOutlineIcon
                              className={classes.collapseIcon}
                            />
                          ) : (
                            <AddCircleOutlineIcon
                              className={classes.expandIcon}
                            />
                          )}
                        </button>
                      </td>

                      <td>
                        <button
                          onClick={() => handleRemovePO(po.id)}
                          className={classes.deleteIconBtn}
                        >
                          <DeleteOutlineIcon className={classes.deleteIcon} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <button onClick={handleAddPO} className={classes.addButton}>
              Add PO
            </button>

            {/* Item Table */}
            {selectedPO && (
              <div className={classes.itemwrapper}>
                <HeaderTitle
                  titleText={`Items for PO Number ${
                    purchaseOrders.find((po) => po.id === selectedPO)?.poNo
                  }`}
                />

                {/* Responsive Wrapper */}
                <div className={classes.tableResponsiveWrapper}>
                  <table className={classes.potable}>
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Item Code</th>
                        <th>Description</th>
                        <th>Quantity Ordered</th>
                        <th>Quantity Received</th>
                        <th>UOM</th>
                        <th>Unit Price</th>
                        <th>Total Price</th>
                        <th>Remarks</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {(items[selectedPO] || []).map((item, index) => (
                        <tr key={index}>
                          <td style={{ width: "200px" }}>
                            {/* <Select
                            options={getpoItems.map((itemOption) => ({
                              value: itemOption.item_code,
                              label: `${itemOption.item_name} (${itemOption.item_code})`,
                            }))}
                            onChange={(selectedOption) =>
                              handleItemInputChange(
                                selectedPO,
                                index,
                                "item_code",
                                selectedOption.value
                              )
                            }
                            placeholder="Select Item..."
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                              control: (base) => ({
                                ...base,
                                minHeight: "42px",
                                fontSize: "15px",
                                paddingLeft: "4px",
                                width: "200px",
                              }),

                              menu: (base) => ({
                                ...base,
                                width: "200px",
                                fontSize: "12px",
                                zIndex: 9999,
                              }),

                              option: (base, { isFocused, isSelected }) => ({
                                ...base,
                                fontSize: "12px",
                                padding: "10px 12px",
                                backgroundColor: isSelected
                                  ? "#007bff"
                                  : isFocused
                                  ? "#e6f0ff"
                                  : "#fff",
                                color: isSelected ? "#fff" : "#000",
                              }),
                            }}
                          /> */}

                            <input
                              type="text"
                              className={classes.mediumInput}
                              value={item.name}
                              readOnly
                            />
                          </td>

                          {/* ITEM CODE (medium) */}
                          <td>
                            <input
                              type="text"
                              className={classes.mediumInput}
                              value={item.item_code}
                              readOnly
                            />
                          </td>

                          {/* DESCRIPTION (extra wide) */}
                          <td>
                            <input
                              type="text"
                              className={classes.extraWideInput}
                              value={item.description}
                              onChange={(e) =>
                                handleItemInputChange(
                                  selectedPO,
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className={classes.smallInput}
                              value={item.quantityOrdered}
                              onChange={(e) =>
                                handleItemInputChange(
                                  selectedPO,
                                  index,
                                  "quantityOrdered",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          {/* QUANTITY RECEIVED (small) */}
                          <td>
                            <input
                              type="number"
                              className={classes.smallInput}
                              value={item.quantityReceived}
                              onChange={(e) =>
                                handleItemInputChange(
                                  selectedPO,
                                  index,
                                  "quantityReceived",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          {/* UOM (medium) */}
                          <td>
                            <input
                              type="text"
                              className={classes.mediumInput}
                              value={item.uom}
                              onChange={(e) =>
                                handleItemInputChange(
                                  selectedPO,
                                  index,
                                  "uom",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          {/* UNIT PRICE (small) */}
                          <td>
                            <div
                              style={{
                                position: "relative",
                                width: "fit-content",
                              }}
                            >
                              <span
                                style={{
                                  position: "absolute",
                                  left: "8px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontWeight: 600,
                                  color: "#555",
                                  pointerEvents: "none",
                                }}
                              >
                                ₹
                              </span>

                              <input
                                type="text"
                                className={classes.smallInput}
                                value={Number(item.unitPrice).toLocaleString(
                                  "en-IN"
                                )}
                                readOnly
                                style={{ paddingLeft: "22px" }}
                              />
                            </div>
                          </td>

                          {/* TOTAL PRICE (small) */}
                          <td>
                            <div
                              style={{
                                position: "relative",
                                width: "fit-content",
                              }}
                            >
                              <span
                                style={{
                                  position: "absolute",
                                  left: "8px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontWeight: 600,
                                  color: "#555",
                                  pointerEvents: "none",
                                }}
                              >
                                ₹
                              </span>

                              <input
                                type="text"
                                className={classes.smallInput}
                                value={Number(item.totalPrice).toLocaleString(
                                  "en-IN"
                                )}
                                readOnly
                                style={{ paddingLeft: "22px" }}
                              />
                            </div>
                          </td>

                          {/* REMARKS (extra wide) */}
                          <td>
                            <input
                              type="text"
                              className={classes.extraWideInput}
                              value={item.remarks}
                              onChange={(e) =>
                                handleItemInputChange(
                                  selectedPO,
                                  index,
                                  "remarks",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          {/* ACTION (delete icon) */}
                          <td>
                            <button
                              onClick={() =>
                                handleRemoveItem(selectedPO, index)
                              }
                              className={classes.deleteIconBtn}
                            >
                              <DeleteOutlineIcon
                                className={classes.deleteIcon}
                              />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button
                  onClick={() => handleAddItem(selectedPO)}
                  className={classes.addButton}
                >
                  Add Item
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className={classes.grnContainer}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={(event, newValue) => setTabValue(newValue)}
              >
                <Tab
                  label="Active GRN"
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                />
                <Tab
                  label="Completed GRN"
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                />
              </Tabs>
            </Box>

            {tabValue === 0 ? (
              <div className={classes.tableResponsiveWrapper}>
                <GRNTable
                  title="Active GRN"
                  data={paginatedActiveGRN}
                  poInvoiceMap={poInvoiceMap}
                />
              </div>
            ) : (
              <div className={classes.tableResponsiveWrapper}>
                <GRNTable
                  title="Completed GRN"
                  data={paginatedCompletedGRN}
                  poInvoiceMap={poInvoiceMap}
                />
              </div>
            )}
          </div>
        )}

        {getviewgrn &&
          Object.values(items).some((poItems) => poItems.length > 0) && (
            <button className={classes.saveButton} onClick={handleSaveGRN}>
              Save GRN
            </button>
          )}

        <Modal open={successpopup}>
          <Fade in={successpopup}>
            <Box>
              <SuccessPopupDashboard
                popupImage={successPopupImg}
                popupHeroText={getuserpopupherotext}
                popBtn={true}
                vendorBtn={true}
                btnText={"Okay"}
                btnClick={sentUserMessage}
              />
            </Box>
          </Fade>
        </Modal>

        <TablePagination
          component="div"
          count={
            tabValue === 0
              ? filteredActiveGRN.length
              : filteredCompletedGRN.length
          }
          page={(tabValue === 0 ? activePage : completedPage) - 1}
          rowsPerPage={ROWS_PER_PAGE}
          rowsPerPageOptions={[10]}
          onPageChange={(_, newPage) => {
            tabValue === 0
              ? setActivePage(newPage + 1)
              : setCompletedPage(newPage + 1);
          }}
          sx={{
            mt: 1.5,
            "& .MuiTablePagination-toolbar": {
              minHeight: 64,
              paddingLeft: 8,
              paddingRight: 8,
            },
            "& .MuiTablePagination-displayedRows": {
              fontSize: "14px",
              fontWeight: 500,
            },
            "& .MuiIconButton-root": {
              fontSize: "22px",
              padding: "10px",
            },
          }}
        />
      </div>
    </>
  );
};

const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const GRNTable = ({ title, data, poInvoiceMap }) => {
  return (
    <table className={classes.grnTable}>
      <thead>
        <tr>
          <th>GRN NO</th>
          <th>PO No</th>
          <th>Invoice No</th>
          <th>Vendor</th>
          <th>Receiver</th>
          <th>Item</th>
          <th>Ordered</th>
          <th>Received</th>
          <th>Created At</th>
          <th>Total Price</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((grn) => (
            <tr key={grn.id}>
              <td>{grn.id}</td>
              <td>{grn.purchase_order_no}</td>
              <td>{poInvoiceMap?.[grn.purchase_order_no] || "-"}</td>
              <td>{grn.vendor}</td>
              <td>{grn.receiver_name}</td>
              <td>{grn.item_name}</td>
              <td>{grn.quantity_ordered}</td>
              <td>{grn.quantity_received}</td>
              <td>{formatDateTime(grn.created_at)}</td>

              <td>₹{Number(grn.total_price).toLocaleString("en-IN")}</td>
              <td>{grn.remarks}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8">No {title.toLowerCase()} found.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default GRNSystem;
